import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-165d080a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "fs-7 fw-bold text-break" }

import { PropType, computed, ComputedRef } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  userType: {
    type: String as PropType<'alumni' | 'employee' | 'yelloop' | 'community_admin' | 1 | 2 | 3>,
    default: 'alumni',
  },
  title: String,
  titleOther: String,
},
  setup(__props) {

const props = __props



const srcUrl = {
  employee: require('@/assets/images/user-attribute-orange.svg'),
  alumni: require('@/assets/images/user-attribute-green.svg'),
  yelloop: require('@/assets/images/user-attribute-green.svg'),
  community_admin: require('@/assets/images/user-attribute-gray.svg'),
  1: require('@/assets/images/user-attribute-orange.svg'), // employee
  2: require('@/assets/images/user-attribute-green.svg'), // alumnai
  3: require('@/assets/images/user-attribute-gray.svg'),
  null: require('@/assets/images/user-attribute-gray.svg'),
}

const imgSrc: ComputedRef<string> = computed(() => srcUrl[props.userType])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(imgSrc),
      alt: "user attribute",
      class: _normalizeClass(['me-2', props.userType === 'employee' ? 'icon-user-employee' : 'icon-user'])
    }, null, 10, _hoisted_2),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.title) + " " + _toDisplayString(__props.titleOther), 1)
  ]))
}
}

})